import { Dimensions } from "react-native";

const { width: W } = Dimensions.get("window");

function sizeNormalizer<T, U, K, X>(
  max_576: T,
  max_768?: U,
  max_992?: K,
  min_1200?: X
) {
  return W < 576
    ? max_576
    : W < 768
    ? max_768 ?? max_576
    : W < 992
    ? max_992 ?? max_576
    : min_1200 ?? max_576;
}

export default sizeNormalizer;

// function sizeNormalizer(
//   max_576: number | string,
//   max_768 = max_576,
//   max_992 = max_576,
//   min_1200 = max_576
// ): number | string {
//   return W <= 576
//     ? max_576
//     : W <= 768
//     ? max_768
//     : W <= 992
//     ? max_992
//     : min_1200;
// }

// export default sizeNormalizer;
